const getInactivityTimeout = (): number => {
  const timeout = parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT_MINUTES || '15', 10);

  if (isNaN(timeout) || timeout < 1 || timeout > 15) {
    console.warn(
      `Invalid timeout value: ${process.env.REACT_APP_INACTIVITY_TIMEOUT_MINUTES}. Using default: 15`,
    );
    return 15;
  }
  return timeout;
};

export const config = {
  inactivityTimeout: getInactivityTimeout(),
} as const;
